"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserAesDecrypt = browserAesDecrypt;
exports.browserAesEncrypt = browserAesEncrypt;
exports.browserExportKey = browserExportKey;
exports.browserHmacSha256Sign = browserHmacSha256Sign;
exports.browserHmacSha512Sign = browserHmacSha512Sign;
exports.browserImportKey = browserImportKey;
exports.browserSha256 = browserSha256;
exports.browserSha512 = browserSha512;
exports.getAlgo = getAlgo;
exports.getOps = getOps;

var env = _interopRequireWildcard(require("@walletconnect/environment"));

var _constants = require("../constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getAlgo(type) {
  return type === _constants.AES_BROWSER_ALGO ? {
    length: _constants.AES_LENGTH,
    name: _constants.AES_BROWSER_ALGO
  } : {
    hash: {
      name: _constants.HMAC_BROWSER_ALGO
    },
    name: _constants.HMAC_BROWSER
  };
}

function getOps(type) {
  return type === _constants.AES_BROWSER_ALGO ? [_constants.ENCRYPT_OP, _constants.DECRYPT_OP] : [_constants.SIGN_OP, _constants.VERIFY_OP];
}

async function browserExportKey(cryptoKey) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.AES_BROWSER_ALGO;
  const subtle = env.getSubtleCrypto();
  return new Uint8Array(await subtle.exportKey("raw", cryptoKey));
}

async function browserImportKey(buffer) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.AES_BROWSER_ALGO;
  return env.getSubtleCrypto().importKey("raw", buffer, getAlgo(type), true, getOps(type));
}

async function browserAesEncrypt(iv, key, data) {
  const subtle = env.getSubtleCrypto();
  const cryptoKey = await browserImportKey(key, _constants.AES_BROWSER_ALGO);
  const result = await subtle.encrypt({
    iv,
    name: _constants.AES_BROWSER_ALGO
  }, cryptoKey, data);
  return new Uint8Array(result);
}

async function browserAesDecrypt(iv, key, data) {
  const subtle = env.getSubtleCrypto();
  const cryptoKey = await browserImportKey(key, _constants.AES_BROWSER_ALGO);
  const result = await subtle.decrypt({
    iv,
    name: _constants.AES_BROWSER_ALGO
  }, cryptoKey, data);
  return new Uint8Array(result);
}

async function browserHmacSha256Sign(key, data) {
  const subtle = env.getSubtleCrypto();
  const cryptoKey = await browserImportKey(key, _constants.HMAC_BROWSER);
  const signature = await subtle.sign({
    length: _constants.HMAC_LENGTH,
    name: _constants.HMAC_BROWSER
  }, cryptoKey, data);
  return new Uint8Array(signature);
}

async function browserHmacSha512Sign(key, data) {
  const subtle = env.getSubtleCrypto();
  const cryptoKey = await browserImportKey(key, _constants.HMAC_BROWSER);
  const signature = await subtle.sign({
    length: _constants.LENGTH_512,
    name: _constants.HMAC_BROWSER
  }, cryptoKey, data);
  return new Uint8Array(signature);
}

async function browserSha256(data) {
  const subtle = env.getSubtleCrypto();
  const result = await subtle.digest({
    name: _constants.SHA256_BROWSER_ALGO
  }, data);
  return new Uint8Array(result);
}

async function browserSha512(data) {
  const subtle = env.getSubtleCrypto();
  const result = await subtle.digest({
    name: _constants.SHA512_BROWSER_ALGO
  }, data);
  return new Uint8Array(result);
}